// Utility function to get display name from player with profile data
interface PlayerWithProfile {
  name: string;
  auth_user_id?: string;
  profiles?: {
    display_name?: string;
  } | null;
}

export const getPlayerDisplayName = (player: PlayerWithProfile): string => {
  // If player is linked to auth user and has a profile display name, use that
  if (player.auth_user_id && player.profiles?.display_name) {
    return player.profiles.display_name;
  }
  
  // Otherwise use the player's name
  return player.name;
};

// For players array
export const getPlayerDisplayNameById = (playerId: string, players: any[]): string => {
  const player = players.find(p => p.id === playerId);
  if (!player) return 'Unknown Player';
  
  return getPlayerDisplayName(player);
};
